import { ClientUnreadNotificationCountDocument } from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import { useQuery } from "@apollo/client";

export const useClientUnreadNotificationCountQuery = (shouldSkip: boolean) => {
  useQuery(ClientUnreadNotificationCountDocument, {
    skip: shouldSkip,
    pollInterval: 1000 * 30, // every 30 seconds
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      useAuthState
        .getState()
        .setUnreadNotificationCount(data?.clientUnreadNotificationCount?.count ?? 0);
    },
  });
};
